import React from 'react';
import { Link } from 'react-router-dom';

import Authenticated from 'Components/Layouts/Authenticated';
import { Loading } from 'Components/Partials';
import SocketIndicator from 'Components/Utilities/SocketIndicator';

import User from 'Services/User';
import { translation } from 'Services/TranslationHelpers';

import Base from './Base';
import { asset } from "Services/BaseHelpers";
import MainstageQuestionsStandAlone from "Components/MainStage/MainStageQuestionsStandAlone";
import MainStageChatStandAlone from "Components/MainStage/MainStageChatStandAlone";

export default class MainStageChat extends Base {
    /**
     * @var success
     * @type {boolean}
     */
    remote_control = false;

    /**
     * @var state
     */
    state = {
        working: false,
        sessions: null,
        currentSession: null,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.mountBase();
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        this.unmountBase();
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { working, currentSession } = this.state;
        const params = new URLSearchParams(window.location.search);
        const screenMode = params.get('screen') === '1';
        const aspect = params.get('aspect'); // 'side' for 1152x1536

        const rootClass = screenMode
            ? 'bg-gradient-to-br bg-cover from-app-blue via-white to-app-light-blue min-h-screen w-full flex items-center justify-center flex flex-col h-full'
            : 'bg-white bg-cover bg-no-repeat h-full w-full  min-h-screen';

        const innerStyle = screenMode && aspect !== 'side' ? { aspectRatio: '16 / 9' } : {};

        return (
            <div className={rootClass}>
                <div style={innerStyle}>
                    {/*{!screenMode && (*/}
                    {/*    <div className=" w-full flex justify-center items-center pt-36 md:pt-0 mb-5">*/}
                    {/*        <img*/}
                    {/*            src={ asset ( '/images/box-text.png' ) }*/}
                    {/*            alt="logo"*/}
                    {/*            className="h-60"*/}
                    {/*        />*/}
                    {/*    </div>*/}
                    {/*)}*/}

                    <div className={`${screenMode ? 'p-4 lg:px-8 flex-1 flex items-center justify-center' : 'p-4 md:px-0 '} mx-auto mt-12 px-4 relative z-10 w-full h-full`}>
                        {working && (<Loading />)}

                        {!working && (
                            <React.Fragment>
                                {!currentSession &&
                                    <div className="flex flex-col items-center justify-center w-full">
                                        <div className="bg-white/90 rounded-2xl pb-12 max-w-2xl mx-auto">
                                            <p className="font-extrabold text-2xl text-indigo-700 text-center tracking-tight">
                                                {translation('main_stage_frontend', 'no_sessions_live_come_back_later')}
                                            </p>
                                        </div>
                                    </div>
                                }

                                {currentSession &&
                                    <div className="w-full flex justify-center">
                                        <div className="rounded-2xl pb-8 w-full max-w-4xl">
                                            <MainStageChatStandAlone
                                                readOnly={true}
                                                sessionId={this.state.currentSession.id}
                                                heightClass={screenMode ? 'h-full' : ''}
                                                restrictWidth={!screenMode ? false : false}
                                            />
                                        </div>
                                    </div>
                                }
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    /**
     * @method renderQuestion
     * @return {JSX.Element}
     */
    renderQuestion = (screenMode = false) => (
        <MainStageChatStandAlone
            readOnly={true}
            sessionId={this.state.currentSession.id}
            heightClass={screenMode ? 'h-full' : ''}
            restrictWidth={!screenMode ? false : false}
        />
    );
}
